export default __webpack_public_path__ + "static/media/StatusDoctorFill.ed268812.svg";